import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
html {
    box-sizing: border-box;
}
*, *::after, *::before {
    box-sizing: inherit;
}
body {
    font-family: 'Outfit', sans-serif;
    overflow-x: hidden;
    max-width: 100vw;
    padding: 10px;
}
a, button, textarea {
    font-family: 'Outfit', sans-serif;
}
input, textarea {
    font-size: ${({ theme }) => theme.fontSize.Input} !important;
}
`;
